import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CfcSplitOnOwnerPercentEditService {

  constructor(private http: HttpClient) {}

  saveData(
    baseUrl: string,
    returnClobSettingsObj: any,
    dataToSave: any[],
    globalParams: any,
    filterParams: any = {},
  ): Observable<any> {
    const jsonObj = JSON.stringify(dataToSave);
    const jsonSettings = JSON.stringify(returnClobSettingsObj);

    const params: any = { ...globalParams, ...filterParams };
    params.clob_data = jsonObj;
    params.clob_settings = jsonSettings;
    params.sso_id = returnClobSettingsObj?.sso_id || globalParams?.sso_id || '';
    params.tax_year = filterParams?.tax_year || globalParams?.tax_year || '';
    params.scenario = filterParams?.scenario || globalParams?.scenario || '';
    params.jcd_key = filterParams?.jcd_key || globalParams?.jcd_key || '';
    params.screen_key = filterParams?.screen_key || globalParams?.screen_key || '';

    const body = new URLSearchParams();
    Object.keys(params).forEach(k => {
      if (params[k] !== undefined && params[k] !== null) {
        body.set(k, String(params[k]));
      }
    });

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=fa0ocb`,
      body.toString(),
      { headers, withCredentials: true },
    );
  }

  checkLockStatus(
    baseUrl: string,
    p_scenario: string,
    p_jcd_key: string,
    globalParams: any,
    filterParams: any = {},
  ): Observable<any> {
    return this._loadJsonObject(baseUrl, {
      action_code: 'n10cpv',
      p_scenario: p_scenario || filterParams?.scenario || globalParams?.scenario || '',
      p_jcd_key: p_jcd_key || filterParams?.jcd_key || globalParams?.jcd_key || '',
      tax_year: filterParams?.tax_year || globalParams?.tax_year || '',
      scenario: filterParams?.scenario || globalParams?.scenario || '',
      jcd_key: filterParams?.jcd_key || globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalParams?.screen_key || '',
    });
  }

  getEoYAdjustmentDtls(
    baseUrl: string,
    cfc_combination_key: number,
    split_on_ownership: string,
    globalParams: any,
    filterParams: any = {},
  ): Observable<any> {
    return this._loadJsonObject(baseUrl, {
      action_code: 'y3tal3',
      p_cfc_combination_key: cfc_combination_key,
      p_split_on_ownership: split_on_ownership,
      tax_year: filterParams?.tax_year || globalParams?.tax_year || '',
      scenario: filterParams?.scenario || globalParams?.scenario || '',
      jcd_key: filterParams?.jcd_key || globalParams?.jcd_key || '',
      screen_key: filterParams?.screen_key || globalParams?.screen_key || '',
    });
  }

  /**
   * /loadJsonObject = ALWAYS HTTP GET with query string params (playbook 5.1)
   */
  private _loadJsonObject(baseUrl: string, params: any): Observable<any> {
    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, String(params[key]));
      }
    });

    return this.http.get<any>(
      `${baseUrl}/loadJsonObject?${urlParams.toString()}`,
      { withCredentials: true },
    );
  }
}
